import React, { useState } from 'react';
import { useLanguage } from '../../../shared/contexts/LanguageContext';
import { useLogout } from '../../../hooks/useLogout';
import { useDesign } from '../../../v2/design/DesignContext';

const LogoutButton: React.FC = () => {
  const { logout, isLoggingOut } = useLogout();
  const { t, language, setLanguage, isRTL } = useLanguage();
  const [showConfirm, setShowConfirm] = useState(false);
  const { canSwitch, setDesign } = useDesign();

  const handleLogoutClick = () => {
    setShowConfirm(true);
  };

  const handleConfirmLogout = () => {
    setShowConfirm(false);
    logout();
  };

  const handleCancelLogout = () => {
    setShowConfirm(false);
  };

  return (
    <>
      {/* Logout and Language Toggle Container */}
      <div className={`hidden sm:flex fixed top-6 z-50 flex-col gap-3 ${isRTL ? 'left-6 items-start' : 'right-6 items-end'}`}>
        {/* Logout Button */}
        <div className="flex gap-2 items-center">
          <button
            onClick={handleLogoutClick}
            disabled={isLoggingOut}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
              isLoggingOut
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                : 'bg-red-500 hover:bg-red-600 text-white cursor-pointer shadow-lg hover:shadow-xl'
            }`}
            style={{
              minWidth: '80px',
              fontSize: '14px',
            }}
          >
            {isLoggingOut ? '...' : t('logout')}
          </button>
        </div>

        {/* Language Toggle */}
        <div className="flex items-center gap-1 bg-white rounded-full p-1 shadow-md min-w-[100px]">
          <button
            onClick={() => setLanguage('ar')}
            className={`px-3 py-1 rounded-full text-sm font-medium transition-all duration-200 flex-1 text-center ${
              language === 'ar'
                ? 'bg-[#2e5d7d] text-white shadow-sm'
                : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            ع
          </button>
          <button
            onClick={() => setLanguage('en')}
            className={`px-3 py-1 rounded-full text-sm font-medium transition-all duration-200 flex-1 text-center ${
              language === 'en'
                ? 'bg-[#2e5d7d] text-white shadow-sm'
                : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            EN
          </button>
        </div>

        {/* Switch to the new design («التصميم الجديد») */}
        {canSwitch && (
          <button
            onClick={() => setDesign('v2')}
            className="px-3 py-1 rounded-full text-sm font-medium bg-white text-[#2e5d7d] shadow-md hover:shadow-lg transition-all duration-200"
          >
            {t('switch_to_new_design')}
          </button>
        )}
      </div>

      {/* Logout Confirmation Modal */}
      {showConfirm && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-2xl p-6 max-w-sm w-full mx-4 shadow-2xl">
            <h3 className="text-lg font-semibold text-gray-900 mb-3">
              {t('confirm_logout')}
            </h3>
            <p className="text-gray-600 mb-6 text-sm">
              {t('logout_confirmation_message')}
            </p>
            <div className="flex gap-3">
              <button
                onClick={handleCancelLogout}
                className="flex-1 px-4 py-2 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition-all"
              >
                {t('cancel')}
              </button>
              <button
                onClick={handleConfirmLogout}
                className="flex-1 px-4 py-2 rounded-lg bg-red-600 text-white font-medium hover:bg-red-700 transition-all"
              >
                {t('logout')}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LogoutButton; 